import { z } from 'zod';

export const ConnectorStatusSchema = z.enum(['connected', 'not_connected', 'error']);

export const ConnectorConfigSchema = z.object({
  status: ConnectorStatusSchema,
  connectedAt: z.string().nullable(),
  connectedBy: z.string().nullable(),
  fingerprint: z.string().nullable(),
  lastRefreshErrorAt: z.string().nullable(),
});

export const ConnectorSchema = z.object({
  id: z.string(),
  name: z.string(),
  authType: z.enum(['api_key', 'oauth2']),
  transport: z.string(),
  tools: z.array(z.string()),
  config: ConnectorConfigSchema.nullable(),
});

export const ConnectorListResponseSchema = z.object({
  connectors: z.array(ConnectorSchema),
});

export const MemberConnectorGrantSchema = z.object({
  id: z.string(),
  name: z.string(),
  authType: z.enum(['api_key', 'oauth2']),
  status: ConnectorStatusSchema,
  granted: z.boolean(),
  operationAllowlist: z.array(z.string()).nullable(),
});

export const MemberConnectorGrantsResponseSchema = z.object({
  connectors: z.array(MemberConnectorGrantSchema),
});

export const ConnectorGrantSchema = z.object({
  memberId: z.string(),
  memberName: z.string(),
  isAi: z.boolean(),
  granted: z.boolean(),
  operationAllowlist: z.array(z.string()).nullable(),
});

export const ConnectorGrantsResponseSchema = z.object({
  grants: z.array(ConnectorGrantSchema),
});

export const BeginOAuthResponseSchema = z.object({
  authorizationUrl: z.string(),
});

export type Connector = z.infer<typeof ConnectorSchema>;
export type ConnectorStatus = z.infer<typeof ConnectorStatusSchema>;
export type ConnectorGrant = z.infer<typeof ConnectorGrantSchema>;
export type MemberConnectorGrant = z.infer<typeof MemberConnectorGrantSchema>;

export const ConnectorOperationSchema = z.object({
  name: z.string(),
  description: z.string(),
  inputSchema: z.record(z.unknown()),
});

export const MyGrantsConnectorSchema = z.object({
  id: z.string(),
  name: z.string(),
  connectorStatus: ConnectorStatusSchema,
  operations: z.array(ConnectorOperationSchema),
  operationAllowlist: z.array(z.string()).nullable(),
});

export const MyGrantsResponseSchema = z.object({
  memberId: z.string().nullable(),
  connectors: z.array(MyGrantsConnectorSchema),
});

export const InvokeResponseSchema = z.object({
  result: z.string(),
});

export type ConnectorOperation = z.infer<typeof ConnectorOperationSchema>;
export type MyGrantsConnector = z.infer<typeof MyGrantsConnectorSchema>;
export type MyGrantsResponse = z.infer<typeof MyGrantsResponseSchema>;
